import script from "./PasswordReissueDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordReissueDialog.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordReissueDialog.vue?vue&type=style&index=0&id=602021b8&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-602021b8"]])

export default __exports__